import React from 'react';
import PropTypes from 'prop-types';
import HTMLFlipBook from 'react-pageflip';

const getHeightAndWidth = orientation => {
  switch (orientation) {
    case 'portrait':
      return { width: 230, height: 300 };
    case 'square':
      return { width: 300, height: 300 };
    default:
      return { width: 300, height: 230 };
  }
};

const PhotobookPreview = props => {
  const { previewImages, orientation } = props;
  const [, ...previewsExceptFirstPage] = previewImages || [];
  const { width, height } = getHeightAndWidth(orientation);

  return (
    <HTMLFlipBook
      id="photobook"
      width={width}
      height={height}
      size="stretch"
      minWidth={width}
      maxWidth={600}
      minHeight={height}
      maxHeight={600}
      showCover
      maxShadowOpacity={0.5}>
      {previewsExceptFirstPage.map(image => (
        <div key={image}>
          <img
            alt="photobook-preview-page"
            src={image}
            style={{ width: '100%', height: 'auto' }}
          />
        </div>
      ))}
    </HTMLFlipBook>
  );
};

PhotobookPreview.propTypes = {
  previewImages: PropTypes.arrayOf(PropTypes.string),
  orientation: PropTypes.oneOf(['landscape', 'portrait', 'square']),
};

PhotobookPreview.defaultProps = {
  previewImages: null,
  orientation: null,
};

export default PhotobookPreview;
